import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceN',
    standalone: false
})
export class ReplaceNPipe implements PipeTransform {

  transform(value: string): string {
    return value.replace(/\n\n/g, '\n \n');
  }

}
